import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Components, Utils } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import PageNotFound from '../pageNotFound';
import LoginLoading from './loginLoading';

class SsoLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCheckingSsoEnabled: false,
      isAttemptingLogin: false,
    };
  }

  async componentDidMount() {
    const domain = Utils.Router.getParams().domain;
    try {
      this.setState({ isCheckingSsoEnabled: true });
      await this.props.dispatch(ReduxActions.profile.getSsoSetting({ domain }));
      this.setState({ isCheckingSsoEnabled: false });
    } catch (error) {
      this.setState({ isCheckingSsoEnabled: false });
    }
  }

  _ssoLogin = async () => {
    this.setState({
      isAttemptingLogin: true,
    });
    try {
      const loginUrl = await this.props.dispatch(
        ReduxActions.profile.ssoLogin({ domain: Utils.Router.getParams().domain }),
      );
      window.location = loginUrl;
    } catch (error) {
      this.setState({ isAttemptingLogin: false });
    }
  }

  render() {
    if (!this.props.sso_enabled && !this.state.isCheckingSsoEnabled) {
      return <PageNotFound />;
    }
    if (this.state.isCheckingSsoEnabled) {
      return false;
    }
    return (
      this.state.isAttemptingLogin ? <LoginLoading /> : (
        <div className="vf-authentication__sso-login__form-container">
          <div className="vf-authentication__sso-login__text">
            Hello, there!
          </div>

          <div className="vf-authentication__sso-login__text--bold">
            Login using your ADID credentials
          </div>

          <div className="vf-authentication__sso-login__login-button-container">
            <Components.Button
              className="vf-authentication__sso-login__login-button-container__button"
              fillColor
              onClick={this._ssoLogin}
            >
              <img
                alt="Login"
                className="vf-authentication__sso-login__login-button-container__button__image"
                src="/assets/images/versafleet.png"
              />
            </Components.Button>
          </div>
          <div className="vf-authentication__sso-login__text__description">
            Request for a service order from the transport team.
          </div>

        </div>
      ));
  }
}

SsoLogin.displayName = 'SsoLogin';

SsoLogin.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      domain: PropTypes.string,
    }),
  }).isRequired,
  sso_enabled: PropTypes.bool,
};

SsoLogin.defaultProps = {
  sso_enabled: null,
};

function mapStateToProps(state) {
  const { profile } = state;
  return {
    sso_enabled: profile.sso_enabled,
  };
}

export default connect(mapStateToProps)(SsoLogin);
